import TagsReducer from "../../Tags/redux/reducer";
import LiveFeedReducer from "./reducer";

export const setLiveFeedList = (payload) => (dispatch) => {
  dispatch(LiveFeedReducer.actions.setLiveFeedList(payload));
};

export const setSelectFeed = (payload) => (dispatch) => {
  dispatch(LiveFeedReducer.actions.setSelectFeed(payload));
};

export const addTagToList = (payload) => (dispatch) => {
  dispatch(TagsReducer.actions.addList(payload));
};

export const updateTagsList = (payload) => (dispatch) => {
  dispatch(TagsReducer.actions.updateTagsList(payload));
};

export const clearSelectedTag = () => (dispatch) => {
  dispatch(TagsReducer.actions.clearSelectItems());
};

export const clearSelectFeed = () => (dispatch) => {
  dispatch(LiveFeedReducer.actions.clearSelectFeed());
};

export const openCreateTagModal = () => (dispatch) => {
  dispatch(TagsReducer.actions.openCreateTagModal());
};

export const closeCreateTagModal = () => (dispatch) => {
  dispatch(TagsReducer.actions.closeCreateTagModal());
};
